import { enableProdMode } from '@angular/core';
import { environment } from '../environments/environment';
if (environment.production) {
    enableProdMode();
}
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// /build/client-cms/src/app/app.module.ts.pre-build-optimizer.js